import { DotLegalHeader, DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useTranslation } from "@localization/useTranslation";
import { EntityType } from "@common/Common.types";
import DotLegalSection from "@common/components/dotLegalSection/DotLegalSection";
import EvaluationQuestionnaireContent from "@common/components/questionnaireComponents/evaluateQuestionnaireDialog/evaluationQuestionnaireContent/EvaluationQuestionnaireContent";
import { IEvaluatedTaskSection, useEvaluatedTaskSection } from "./EvaluatedTaskSection.hooks";

function EvaluatedTaskSection(props: IEvaluatedTaskSection) {
    const { translateString } = useTranslation();
    const { evaluatedTaskUrl, evaluationUpdater } = useEvaluatedTaskSection(props);

    return (
        <DotLegalSection>
            <DotLegalHeader marginTop={0} marginBottom={0.5} headerStyle="small">
                {translateString("updateOriginalEvaluation")}
            </DotLegalHeader>
            <DotLegalHeader marginTop={0} marginBottom={0} headerStyle="small" fontWeight={400}>
                <Trans
                    i18nKey="updateOriginalEvaluationQuestion"
                    values={{ taskName: props.evaluatedTask.name }}
                    components={{
                        taskLink: (
                            <DotLegalLink bold linkColor="primary" to={evaluatedTaskUrl}>
                                {undefined}
                            </DotLegalLink>
                        ),
                    }}
                />
            </DotLegalHeader>
            <EvaluationQuestionnaireContent
                evaluationStatus={props.evaluatedTask.evaluationStatus}
                evaluation={props.evaluatedTask.evaluation}
                onEvaluationStateChange={evaluationUpdater.onEvaluationStatusChange}
                onEvaluationChange={evaluationUpdater.onEvaluationChange}
                debounce
                disableAutoFocus
                useMentionInput
                entityId={props.evaluatedTask.id}
                entityType={EntityType.Task}
            />
        </DotLegalSection>
    );
}

export default EvaluatedTaskSection;
